// extracted by mini-css-extract-plugin
export default {"Topp":"price_Topp__hOaV8","use":"price_use__wPyDk","Outa":"price_Outa__5OOlz","Inna":"price_Inna__CCi-i","Free":"price_Free__-8jZl","Firstt":"price_Firstt__6chBS"};